// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DYot","placeholdersHeader":"styles_placeholdersHeader__Ab9ES","editorStyle":"styles_editorStyle__hSJfj","placeholdersBox":"styles_placeholdersBox__IH2hN"};